export default {
  message: {
    Wallet_address: 'Wallet Address',
    Log_out: 'Log Out',
    Authorized_contract: 'Approve contract',
    Authorized_token: 'Approve token',
    Authorized_limit: 'Approve limit',
    Change_quota: 'Revoke',
    unlimited: 'unlimited',
    confirm_title: 'Approval limit modification',
    confirm_content: 'Confirm to change the approval quota of the current contract to 0?',
    confirm: 'Confirm',
    cancle: 'Cancel',
    revoke: 'Revoke',
    token: 'Token',
    address: 'Address',
    limit: 'Limit',
    approval: 'Approval',
    action: 'Action',
  },
}
